import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    shippingCountries: [],
    billingCountries: [],
};

const countryList = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.ADD_COUNTRIES_SHIPPING:
        return { ...state, shippingCountries: action.payload };

    case APP_ACTIONS.ADD_COUNTRIES_BILLING:
        return { ...state, billingCountries: action.payload };

    default:
        return state;
    }
};

export default countryList;



/** WEBPACK FOOTER **
 ** ./src/reducers/country-list.js
 **/